import { Injectable, NgZone } from "@angular/core";
import { Platform } from "@ionic/angular";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GlobalsService {
  // propiedad legada para compatibilidad
  public isMobile: boolean;
  public plataforma: string;

  // Subjects/Observables para suscribirse a cambios de plataforma
  private _isMobile$ = new BehaviorSubject<boolean>(false);
  public isMobile$(): Observable<boolean> {
    return this._isMobile$.asObservable();
  }
  constructor(public platform: Platform, private ngZone: NgZone) {
    this.detectPlatform();

    // Escuchar cambios de tamaño en la ventana
    window.addEventListener("resize", () => {
      this.ngZone.run(() => this.detectPlatform());
    });
  }

  private detectPlatform() {
    var isCordova = this.platform.is("cordova");
    var isIos = this.platform.is("ios");
    var isAndroid = this.platform.is("android");
    if (
      ((isAndroid || isIos) &&
        !this.platform.is("desktop")) ||
      this.platform.is("cordova")
    ) {
      this.plataforma = isAndroid && isCordova
        ? "android"
        : isIos && isCordova
        ? "ios"
        : "unknow";
      console.log(
        "🚀 ~ GlobalsService ~ detectPlatform ~ this.plataforma :",
        this.plataforma
      );
      this.isMobile = true;
    } else {
      // ✅ Aquí validamos también por tamaño de pantalla
      if (window.innerWidth <= 1280) {
        // puedes ajustar el breakpoint
        this.plataforma = "mobile-screen";
        this.isMobile = true;
      } else {
        this.plataforma = "desktop";
        this.isMobile = false;
      }
    }

    // emitir el nuevo valor
    try {
      this._isMobile$.next(this.isMobile);
    } catch (e) {
      // noop
    }
  }
}
